import { createStore } from "vuex";
import coursesModule from "./modules/courses/index";
export default createStore({
  modules: { coursesModule },
});
